
import { ref, defineComponent, onMounted, computed } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "overview",
  components: {},
  data() {
    return {
      store: useStore(),
      router: useRouter(),
    };
  },
  setup() {
    const store = useStore();
    let form = ref({});
    let loading = ref(true);
    onMounted(() => {
      setCurrentPageBreadcrumbs("Modalidad de Pago", [
        "Páginas",
        "Dashboard",
      ]);
      store
        .dispatch(Actions.GET_PROVEEDOR)
        .then((response) => {
          loading.value = false;
          form = ref({});
        })
        .catch(() => {
          const [error] = Object.keys(store.getters.getProveedorErrors);
        });
    });
    const currentUser = computed(() => {
      return store.getters.currentUser;
    });
    const currentProveedor = computed(() => {
      return store.getters.currentProveedor;
    });

    return { currentUser, loading, form, currentProveedor };
  },
});
